import { render, staticRenderFns } from "./ReleaseNotesList.vue?vue&type=template&id=688bd1c6&scoped=true"
import script from "./ReleaseNotesList.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesList.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNotesList.vue?vue&type=style&index=0&id=688bd1c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688bd1c6",
  null
  
)

export default component.exports